<script setup lang="ts">
import { onMounted } from 'vue'

import { socket } from '@/lib/socket'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()

onMounted(async () => {
  // Restore the session before the first render decision, so a signed-in user
  // reloading the terminal is not bounced to the landing page for a frame.
  await auth.initialise()

  // The socket is opened once for the life of the tab. Market data is public,
  // so it connects whether or not anyone is signed in - the landing page shows
  // live prices to visitors.
  socket.connect()
})
</script>

<template>
  <RouterView />
</template>
